import { Stack, Text } from "@mantine/core"
import { Card } from "@tfg/ui"
import i18next from "i18next"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { Property } from "~/components/Property.tsx"
import { useGetOrganizationSettingsQuery } from "~/pages/Brand/CommunicationStudio/OrganizationGeneralSettings/hooks/useGetOrganizationSettingsQuery"
import { CustomFieldProductsDetailsInfo } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldProductsDetailsInfo"
import { ITEM_CARD_HEIGHT } from "~/pages/Brand/Products/Details/constants.ts"

type Props = {
  itemReference?: string
  operations: LibraryResponses.EnrichedOperation[]
  customFieldsDefs: LibraryResponses.ProductDetails["customFieldDefinitions"]
}

export const CustomFieldItemCard = ({
  itemReference,
  operations,
  customFieldsDefs,
}: Props) => {
  const allCfv = operations.flatMap((n) => n.customFieldValues)
  const { t } = useTranslation("products")
  return (
    <Card w={400} h={ITEM_CARD_HEIGHT}>
      <Stack gap="xs">
        <Text fw="bold" size="sm">
          {itemReference}
        </Text>
        {customFieldsDefs.length < 1 ? (
          <Text c="dimmed" size="sm">
            {t("traceability.itemCard.noFieldDef")}
          </Text>
        ) : null}
        <CustomFieldProductsDetailsInfo
          customFieldsDefs={customFieldsDefs}
          allCfv={allCfv}
        />
      </Stack>
    </Card>
  )
}

type CustomFieldsProps = {
  product: LibraryResponses.ProductDetails
}

export const ProductCustomFields = ({ product }: CustomFieldsProps) => {
  const { data: org } = useGetOrganizationSettingsQuery()
  const customFieldsDefs = org?.enabledCustomFields || []
  const allCfv = product.operationTree.nodes.flatMap((n) => {
    const cfv =
      n.operation !== "not-entered-yet" ? n.operation.customFieldValues : []
    return cfv
  })
  return (
    <>
      {customFieldsDefs.map((cfd) => {
        const cfv = allCfv.find((cfv) => cfd.id === cfv.customFieldDefinitionId)
        let label = cfd.textContent.TextTranslation.find(
          (l) => l.translation === i18next.language.toUpperCase()
        )
        if (!label) {
          label = cfd.textContent.TextTranslation.find(
            (l) => l.translation === "EN"
          )
        }
        return (
          <Property
            key={cfd.id}
            label={label?.translation ?? ""}
            value={cfv?.value}
          />
        )
      })}
    </>
  )
}
